import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '871359405780071'

export function initMetaPixel(): Promise<void> {
  return new Promise((resolve) => {
    if (typeof window === 'undefined') {
      resolve()
      return
    }

    // Already initialized
    if (window.fbq) {
      resolve()
      return
    }

    // Create fbq function
    const fbq: any = function (...args: any[]) {
      if (fbq.callMethod) {
        fbq.callMethod.apply(fbq, args)
      } else {
        fbq.queue.push(args)
      }
    }

    fbq.push = fbq
    fbq.loaded = true
    fbq.version = '2.0'
    fbq.queue = []

    window.fbq = fbq
    if (!window._fbq) window._fbq = fbq

    // Load Facebook Pixel script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'

    script.onload = () => {
      // Initialize pixel after script loads
      window.fbq('init', PIXEL_ID)
      resolve()
    }

    script.onerror = () => {
      console.error('Failed to load Meta Pixel script')
      resolve()
    }

    const firstScript = document.getElementsByTagName('script')[0]
    if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
    } else {
      document.head.appendChild(script)
    }

    // Initialize immediately (queued until script loads)
    window.fbq('init', PIXEL_ID)
    resolve()
  })
}

export function trackPageView() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackAddToCart(data?: {
  content_name?: string
  content_ids?: string[]
  content_type?: string
  value?: number
  currency?: string
}) {
  if (typeof window !== 'undefined' && window.fbq) {
    const eventData = data || {
      content_name: 'Puentes de Palabras',
      content_ids: ['47494784745692'],
      content_type: 'product',
      value: 6.39,
      currency: 'USD',
    }
    window.fbq('track', 'AddToCart', eventData)
  }
}

export function useMetaPixel() {
  useEffect(() => {
    initMetaPixel().then(() => {
      trackPageView()
    })
  }, [])
}
